import { Observable, ObservableArray, Subscribable } from 'knockout';
import WCCError from 'models/wccError';
import CommunityNavigationWidgetItemModel, { CommunityNavigationWidgetItemConfig } from './item';

export interface CommunityNavigationWidgetGroupConfig extends CommunityNavigationWidgetItemConfig {
    items?: Array<CommunityNavigationWidgetItemModel>
    css?: string
}

export default class CommunityNavigationWidgetGroupModel extends CommunityNavigationWidgetItemModel<CommunityNavigationWidgetGroupConfig> {
    items: ObservableArray<CommunityNavigationWidgetItemModel>
    css: Observable<string>

    toDoCount: Subscribable<number>

    constructor(data: CommunityNavigationWidgetGroupConfig) {
        super(data);

        this.items = this.createCollection(data, 'items');
        this.css = this.createField(data, 'css', '');

        this.toDoCount = this.items.reduce((result, item) => result + item.toDoCount(), () => 0);
    }

    add(item: CommunityNavigationWidgetItemModel) {
        this.items.push(item);
    }

    override canMergeWith(item: CommunityNavigationWidgetItemModel): boolean {
        return item instanceof CommunityNavigationWidgetGroupModel && this.title() == item.title();
    }

    override mergeWith(item: CommunityNavigationWidgetItemModel) {
        if (!this.canMergeWith(item))
            throw new WCCError(messages.InvalidRequest);

        const group = <CommunityNavigationWidgetGroupModel>item;

        group.items().forEach(item => {
            const sibling = this.items().find(i => i.canMergeWith(item));

            if (sibling != undefined)
                sibling.mergeWith(item);
            else
                this.add(item);
        });
    }

    protected override checkIfContainer() {
        return true;
    }

    protected override getId() {
        return 'group:' + this.title();
    }
}